module.exports = __webpack_public_path__ + "media/images/athletes/2209-aaf4c174ff3ec4d13eed5d32f7a90c51.png";